import FormFeedbackBanner from "../../components/forms/FormFeedbackBanner";
import React from "react";
import { Button, Spinner } from "react-bootstrap";
import { useAccountReadiness } from "../../providers/AccountReadinessProvider";
import { Navigate, useLocation } from "react-router-dom";
import { useAppBootstrap } from "../../providers/AppBootstrapProvider";

type ProtectedRouteParams = {
  children: React.ReactNode;
  requireAdmin?: boolean;
};

const ProtectedRoute = ({ children, requireAdmin = false }: ProtectedRouteParams) => {
  const location = useLocation();
  const readiness = useAccountReadiness();
  const { authChecked, claimsChecked, isAuthenticated, isAdmin } = useAppBootstrap();

  if (!authChecked) return null;
  if (requireAdmin && !claimsChecked) return null;

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  if (readiness.status === "checking") return <div className="p-4" role="status"><Spinner size="sm" /> <span>Checking your account...</span></div>;
  if (readiness.status === "error") return <FormFeedbackBanner tone="error" messageKey={readiness.errorMessage || undefined} dismissible={false}>
    <p>{readiness.errorMessage || "Could not load your account. Check your connection and try again."}</p>
    <Button onClick={() => void readiness.refresh()}>Try again</Button>
  </FormFeedbackBanner>;
  if (readiness.status === "incomplete") return <Navigate to="/finish-signup" replace state={{ from: `${location.pathname}${location.search}` }} />;

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/discover" replace state={{ forbidden: true }} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
